/* eslint-disable no-console */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
import {
  RACButton,
  makeStyles,
  Typography,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACCheckBox,
  RACCOLOR,
  Grid,
  CircularProgress,
} from '@rentacenter/racstrap';
import React from 'react';
import AccordionOpen from '../../../assets/img/Accordion-open.png';
import AccordionClose from '../../../assets/img/Accordion-close.png';
import { withContactStyles, WrappedComponentProps } from './withContactStyles';
import { useState } from 'react';
import { formatDateString, maskData } from '../../../utils/utils';
import { useLocation } from 'react-router-dom';
import { CustomerLocationState } from '../../../types/types';
import {
  NO_RECORD_FOUND_SECTION,
  RECORD_CHECK_NO_DATA_1,
  RECORD_CHECK_NO_DATA_2,
  SectionKey,
  WORKED_HISTORY_ACTIVITY_TYPE_CODES,
} from '../../../constants/constants';
import { useCustomerPaymentSummary } from '../../../context/CustomerPaymentSummary/CustomerPaymentSummaryProvider';
import { RecordCheckUnmaskModal } from '../ContactInformation/RecordCheckUnmaskModal';
import SecondFactor from '../History/TwoFactorPopup';
import { useUserStateContext } from '../../../context/user/user-contexts';
import { useStoreDetails } from '../../../context/Store/StoreProvider';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { recordCheckBoxLog } from '../../../api/Customer';

const useStyles = makeStyles((theme: any) => ({
  refrncInfo: {
    marginLeft: '10%',
  },
  mt: {
    marginTop: theme.typography.pxToRem(12),
    marginLeft: theme.typography.pxToRem(8),
    marginBottom: theme.typography.pxToRem(12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  accordionIconGrid: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '23px',
    cursor: 'pointer',
    width: '23px',
    height: '23px',
    display: 'block',
    float: 'left',
    marginTop: '1px',
  },
  me2: {
    marginRight: theme.typography.pxToRem(8),
  },
  Checkbox: {
    color: `${RACCOLOR.DEEP_SKY_BLUE}`,
    marginLeft: '-33px',
  },
  Checkbox1: {
    color: `${RACCOLOR.DEEP_SKY_BLUE}`,
    marginLeft: '-10px',
  },
  racGrid: {
    '& th': {
      fontFamily: 'OpenSans-semibold',
      fontSize: '14px',
      color: '#000',
    },
    '& td': {
      fontFamily: 'OpenSans-semibold',
      fontSize: '14px',
      color: '#4A5174',
    },
  },
  px1: {
    paddingLeft: theme.typography.pxToRem(8),
  },
  px2: {
    paddingLeft: theme.typography.pxToRem(22),
  },
  px3: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem',
  },
  tableRow: {
    '& > *': {
      padding: '8px 14px',
    },
  },
  tableRow1: {
    '& > *': {
      padding: '10px 8px',
    },
  },
  noData: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16%',
  },
  noResults: {
    marginLeft: '1rem',
    padding: '1rem',
    textAlign: 'center',
  },
  masterLoader: {
    position: 'fixed',
    backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.6,
    zIndex: 1050,
    textAlign: 'center',
    margin: 0,
  },
  Loader: {
    display: 'block',
    position: 'fixed',
    zIndex: 1051,
    top: '50%',
    right: '50%',
  },
  tableContent: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
}));

const ContactInformationRecordCheckContent_ = ({
  classes,
  onLogClicked,
  onFieldVisitClicked,
  onEmailLogClicked,
}: WrappedComponentProps) => {
  const [openSection, setOpenSection] = useState<string | null>(null);
  const [unmaskmdl, setUnmaskmdl] = useState<boolean>(false);
  const [unmaskbtn, setUnmaskbtn] = useState<boolean>(false);
  const [openSLA, setOpenSLA] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);

  const cusClasses = useStyles();
  const location = useLocation<CustomerLocationState>();
  const {
    recordCheckData,
    setRecordCheckDataUnmask,
    recordCheckDataUnmask: storedRecordCheckDataUnmask,
    setRecordCheckData,
    isLegalHoldProtected,
  } = useCustomerDetails();
  const recordCheckDataUnmask =
    storedRecordCheckDataUnmask && !isLegalHoldProtected;
  const { user } = useUserStateContext();
  const { customerPaymentSummary: customerPaymentSummaryResponse } =
    useCustomerPaymentSummary();
  const { customerDataUnmaskingThresholdDays } = useStoreDetails();
  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];
  const daysPastDue = Number(
    customerPaymentSummaryResponse?.pastDueSummary?.daysPastDue ?? 0
  );

  const handleToggle = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };

  const unmaskBtnClick = () => {
    if (isLegalHoldProtected) return;
    setUnmaskmdl(true);
  };

  const SLACanceled = () => {
    setOpenSLA(false);
  };

  const handleCheckboxChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number,
    type: 'phone' | 'employer' | 'reference'
  ) => {
    const customerId = recordCheckData?.tloCustomerId;
    const selection = e.target.checked;

    const payload = {
      tloCustomerId: String(customerId),
      doNotContact: selection ? 'Y' : 'N',
      tloPhoneId: String(id),
    };

    setLoader(true);

    try {
      const res = await recordCheckBoxLog(payload);

      if (res?.status === '200' && res?.tloPhoneId) {
        const updatedRecordCheckData = { ...recordCheckData };

        const updateList = <
          T extends {
            tloPhoneId: number | string;
            doNotContact: string | boolean;
          }
        >(
          list: T[]
        ): T[] =>
          list.map((item) =>
            String(item.tloPhoneId) === res.tloPhoneId
              ? { ...item, doNotContact: selection ? '1' : '0' }
              : item
          );

        if (type === 'phone') {
          updatedRecordCheckData.phones = updateList(
            recordCheckData?.phones || []
          );
        } else if (type === 'employer') {
          updatedRecordCheckData.employers = updateList(
            recordCheckData?.employers || []
          );
        } else if (type === 'reference') {
          updatedRecordCheckData.references = (
            recordCheckData?.references || []
          ).map((ref) => ({
            ...ref,
            phone: {
              ...ref.phone,
              doNotContact:
                String(ref.phone.tloPhoneId) === res.tloPhoneId
                  ? selection
                    ? '1'
                    : '0'
                  : ref.phone.doNotContact,
            },
          }));
        }

        setRecordCheckData(updatedRecordCheckData);
      }
    } catch (error) {
      console.error('Error in handleCheckboxChange:', error);
    } finally {
      setLoader(false);
    }
  };
  const hasRecordCheckData =
    recordCheckData &&
    (recordCheckData.phones?.length ||
      recordCheckData.emails?.length ||
      recordCheckData.addresses?.length ||
      recordCheckData.employers?.length ||
      recordCheckData.references?.length ||
      recordCheckData.transactionDate ||
      recordCheckData.transactionId);

  const renderPhoneTableHead = () => (
    <>
      <RACTableCell>{'Phone Number'}</RACTableCell>
      <RACTableCell>{'Time Zone'}</RACTableCell>
      <RACTableCell>{'Type'}</RACTableCell>
      <RACTableCell>{'Confidence Score'}</RACTableCell>
      <RACTableCell>{'Action'}</RACTableCell>
    </>
  );

  const renderPhoneTableContent = () => (
    <>
      {recordCheckData &&
        recordCheckData.phones.map((phone, index) => (
          <React.Fragment key={index}>
            <RACTableRow
              className={cusClasses.tableRow}
              backgroundColor="white"
            >
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(String(phone.number), {
                    maskType: isLegalHoldProtected
                      ? 'full'
                      : recordCheckDataUnmask &&
                        (phone.doNotContact === false ||
                          phone.doNotContact === '0')
                      ? 'unmaskPH'
                      : 'lastFour',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {phone.timeZone}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {phone.type}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {phone.confidenceScore}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <RACButton
                  variant="outlined"
                  color="primary"
                  className={classes.logButton}
                  disabled={
                    !phone.number || !recordCheckDataUnmask || daysPastDue <= 0
                  }
                  onClick={() =>
                    onLogClicked(
                      String(customerId),
                      String(phone.number),
                      WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                    )
                  }
                >
                  {'Log'}
                </RACButton>
              </RACTableCell>
              <RACTableCell>
                <RACCheckBox
                  size="small"
                  className={cusClasses.Checkbox}
                  name={`checkbox_${index}`}
                  disabled={!phone.number}
                  onChange={(e) =>
                    handleCheckboxChange(e, Number(phone.tloPhoneId), 'phone')
                  }
                  checked={
                    phone.doNotContact === true || phone.doNotContact === '1'
                  }
                  label={'Do not call'}
                />
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        ))}
    </>
  );

  const renderEmailTableHead = () => (
    <>
      <RACTableCell>{'Email'}</RACTableCell>
      <RACTableCell>{'Confidence Score'}</RACTableCell>
      <RACTableCell>{'Action'}</RACTableCell>
    </>
  );

  const renderEmailTableContent = () => (
    <>
      {recordCheckData &&
        recordCheckData.emails.map((email, index) => (
          <React.Fragment key={index}>
            <RACTableRow
              className={cusClasses.tableRow}
              backgroundColor="white"
            >
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(email.email, {
                    maskType: isLegalHoldProtected
                      ? 'full'
                      : recordCheckDataUnmask
                      ? 'none'
                      : 'email',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {email.confidenceScore}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <RACButton
                  variant="outlined"
                  color="primary"
                  className={classes.logButton}
                  disabled={
                    !email.tloEmailId ||
                    !recordCheckDataUnmask ||
                    daysPastDue <= 0
                  }
                  onClick={() =>
                    onEmailLogClicked &&
                    onEmailLogClicked(
                      String(customerId),
                      Number(email.tloEmailId),
                      WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                    )
                  }
                >
                  {'Log'}
                </RACButton>
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        ))}
    </>
  );

  const renderAddressTableHead = () => (
    <>
      <RACTableCell>{'Address'}</RACTableCell>
      <RACTableCell>{'First Seen'}</RACTableCell>
      <RACTableCell>{'Last Seen'}</RACTableCell>
      <RACTableCell>{'Action'}</RACTableCell>
    </>
  );

  const renderAddressTableContent = () => (
    <>
      {recordCheckData &&
        recordCheckData.addresses.map((address, index) => (
          <React.Fragment key={index}>
            <RACTableRow
              className={cusClasses.tableRow}
              backgroundColor="white"
            >
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {isLegalHoldProtected
                    ? '********'
                    : [
                        maskData(address.addressLine, {
                          maskType: recordCheckDataUnmask ? 'none' : 'full',
                        }),
                        address.city,
                        address.state,
                        address.zipCode,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {formatDateString(address.dateFirstSeen)}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {formatDateString(address.dateLastSeen)}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <RACButton
                  variant="outlined"
                  color="primary"
                  className={classes.logButton}
                  disabled={
                    !address.tloAddressId ||
                    !recordCheckDataUnmask ||
                    daysPastDue <= 0
                  }
                  onClick={() =>
                    onFieldVisitClicked &&
                    onFieldVisitClicked(
                      Number(address.tloAddressId),
                      WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                    )
                  }
                >
                  {'Log Field Visit'}
                </RACButton>
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        ))}
    </>
  );

  const renderEmployerTableHead = () => (
    <>
      <RACTableCell>{'Business Name'}</RACTableCell>
      <RACTableCell>{'Phone Number'}</RACTableCell>
      <RACTableCell>{'Address'}</RACTableCell>
      <RACTableCell>{'Action'}</RACTableCell>
    </>
  );

  const renderEmployerTableContent = () => (
    <>
      {recordCheckData &&
        recordCheckData.employers.map((employer, index) => (
          <React.Fragment key={index}>
            <RACTableRow
              className={cusClasses.tableRow}
              backgroundColor="white"
            >
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(employer.businessName, {
                    maskType: recordCheckDataUnmask ? 'none' : 'full',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(employer.phoneNumber, {
                    maskType: isLegalHoldProtected
                      ? 'full'
                      : recordCheckDataUnmask &&
                        (employer.doNotContact === false ||
                          employer.doNotContact === '0')
                      ? 'unmaskPH'
                      : 'lastFour',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {isLegalHoldProtected
                    ? '********'
                    : [
                        maskData(employer.address.addressLine, {
                          maskType: recordCheckDataUnmask ? 'none' : 'full',
                        }),
                        employer.address.city,
                        employer.address.state,
                        employer.address.zipCode,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <RACButton
                  variant="outlined"
                  color="primary"
                  className={classes.logButton}
                  disabled={
                    (!employer.phoneNumber && !employer.address.tloAddressId) ||
                    !recordCheckDataUnmask ||
                    daysPastDue <= 0
                  }
                  onClick={() => {
                    if (employer.phoneNumber) {
                      onLogClicked(
                        String(customerId),
                        employer.phoneNumber,
                        WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                      );
                    } else if (employer.address.tloAddressId) {
                      onFieldVisitClicked &&
                        onFieldVisitClicked(
                          Number(employer.address.tloAddressId),
                          WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                        );
                    }
                  }}
                >
                  {'Log'}
                </RACButton>
              </RACTableCell>
              <RACTableCell>
                <RACCheckBox
                  size="small"
                  className={cusClasses.Checkbox}
                  name={`checkbox_${index}`}
                  disabled={!employer.phoneNumber}
                  checked={
                    employer.doNotContact === true ||
                    employer.doNotContact === '1'
                  }
                  onChange={(e) =>
                    handleCheckboxChange(
                      e,
                      Number(employer.tloPhoneId),
                      'employer'
                    )
                  }
                  label={'Do not call'}
                />
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        ))}
    </>
  );

  const renderRefTableHead = () => (
    <>
      <RACTableCell>{'Name'}</RACTableCell>
      <RACTableCell>{'Phone Number'}</RACTableCell>
      <RACTableCell>{'Time Zone'}</RACTableCell>
      <RACTableCell>{'Type'}</RACTableCell>
      <RACTableCell>{'Confidence Score'}</RACTableCell>
      <RACTableCell>{'Action'}</RACTableCell>
    </>
  );

  const renderRefTableContent = () => (
    <>
      {recordCheckData &&
        recordCheckData.references.map((reference, index) => (
          <React.Fragment key={index}>
            <RACTableRow
              className={cusClasses.tableRow1}
              backgroundColor="white"
            >
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(reference.name, {
                    maskType: recordCheckDataUnmask ? 'none' : 'full',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {maskData(reference.phone.number, {
                    maskType: isLegalHoldProtected
                      ? 'full'
                      : recordCheckDataUnmask &&
                        (reference?.phone.doNotContact === false ||
                          reference?.phone.doNotContact === '0')
                      ? 'unmaskPH'
                      : 'lastFour',
                  })}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {reference.phone.timeZone}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2">{reference.phone.type}</Typography>
              </RACTableCell>
              <RACTableCell>
                <Typography variant="body2" className={cusClasses.tableContent}>
                  {reference.phone.confidenceScore}
                </Typography>
              </RACTableCell>
              <RACTableCell>
                <RACButton
                  variant="outlined"
                  color="primary"
                  className={classes.logButton}
                  disabled={
                    !reference?.phone?.number ||
                    !recordCheckDataUnmask ||
                    daysPastDue <= 0
                  }
                  onClick={() => {
                    onLogClicked(
                      String(customerId),
                      reference?.phone?.number,
                      WORKED_HISTORY_ACTIVITY_TYPE_CODES.RECORD_CHECK
                    );
                  }}
                >
                  {'Log'}
                </RACButton>
              </RACTableCell>
              <RACTableCell>
                <RACCheckBox
                  size="small"
                  className={cusClasses.Checkbox1}
                  name={`checkbox_${index}`}
                  disabled={!reference?.phone?.number}
                  checked={
                    reference?.phone.doNotContact === true ||
                    reference?.phone.doNotContact === '1'
                  }
                  onChange={(e) =>
                    handleCheckboxChange(
                      e,
                      Number(reference?.phone.tloPhoneId),
                      'reference'
                    )
                  }
                  label={'Do not call'}
                />
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        ))}
    </>
  );

  const NoResultsMessage = () => (
    <Grid container className={cusClasses.px2}>
      <Grid item md={8} className={cusClasses.racGrid}>
        <Typography
          color="textSecondary"
          variant="body1"
          className={cusClasses.noResults}
        >
          {NO_RECORD_FOUND_SECTION}
        </Typography>
      </Grid>
    </Grid>
  );

  const renderTable = (section: SectionKey) => {
    const dataMap: Record<SectionKey, any[] | undefined> = {
      phones: recordCheckData?.phones,
      emails: recordCheckData?.emails,
      addresses: recordCheckData?.addresses,
      employers: recordCheckData?.employers,
      references: recordCheckData?.references,
    };

    const sectionData = dataMap[section];

    if (!sectionData || sectionData.length === 0) {
      return <NoResultsMessage />;
    }

    switch (section) {
      case 'phones':
        return (
          <Grid container className={cusClasses.px2}>
            <Grid item md={8} className={cusClasses.racGrid}>
              <RACTable
                renderTableHead={renderPhoneTableHead}
                renderTableContent={renderPhoneTableContent}
              />
            </Grid>
          </Grid>
        );
      case 'emails':
        return (
          <Grid container className={cusClasses.px2}>
            <Grid item md={8} className={cusClasses.racGrid}>
              <RACTable
                renderTableHead={renderEmailTableHead}
                renderTableContent={renderEmailTableContent}
              />
            </Grid>
          </Grid>
        );
      case 'addresses':
        return (
          <Grid container className={cusClasses.px2}>
            <Grid item md={9} className={cusClasses.racGrid}>
              <RACTable
                renderTableHead={renderAddressTableHead}
                renderTableContent={renderAddressTableContent}
              />
            </Grid>
          </Grid>
        );
      case 'employers':
        return (
          <Grid container className={cusClasses.px2}>
            <Grid item md={9} className={cusClasses.racGrid}>
              <RACTable
                renderTableHead={renderEmployerTableHead}
                renderTableContent={renderEmployerTableContent}
              />
            </Grid>
          </Grid>
        );
      case 'references':
        return (
          <Grid container className={cusClasses.px2}>
            <Grid item md={8} className={cusClasses.racGrid}>
              <RACTable
                renderTableHead={renderRefTableHead}
                renderTableContent={renderRefTableContent}
              />
            </Grid>
          </Grid>
        );
      default:
        return null;
    }
  };

  return hasRecordCheckData ? (
    <div>
      {openSLA === true && !isLegalHoldProtected ? (
        <SecondFactor
          setTwoFactorCancelClick={SLACanceled}
          setTwoFactorCompleted={unmaskBtnClick}
          moduleName={'SensitiveInfoAccess'}
          CurrentRole={user?.role}
        />
      ) : null}

      <RecordCheckUnmaskModal
        open={unmaskmdl && !isLegalHoldProtected}
        onContinue={() => {
          if (isLegalHoldProtected) return;
          setRecordCheckDataUnmask(true);
          setUnmaskbtn(true);
          setUnmaskmdl(false);
        }}
        onClose={() => {
          setUnmaskmdl(false);
        }}
      />
      {loader === true ? (
        <Grid className={cusClasses.masterLoader}>
          <Grid className={cusClasses.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}

      <div className={cusClasses.mt}>
        <div>
          <Typography display="inline" variant="body1">
            Date Created:
          </Typography>
          <Typography
            display="inline"
            variant="body1"
            className={cusClasses.px1}
          >
            {formatDateString(
              recordCheckData && recordCheckData.transactionDate
            )}
          </Typography>
          <Typography
            className={cusClasses.refrncInfo}
            display="inline"
            variant="body1"
            style={{ marginLeft: '1rem' }}
          >
            Reference ID:
          </Typography>
          <Typography
            display="inline"
            variant="body1"
            className={cusClasses.px1}
          >
            {recordCheckData && recordCheckData.transactionId}
          </Typography>
        </div>
        <RACButton
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            if (isLegalHoldProtected) return;
            daysPastDue < customerDataUnmaskingThresholdDays
              ? setOpenSLA(true)
              : unmaskBtnClick();
          }}
          disabled={
            isLegalHoldProtected ||
            daysPastDue <= 0 ||
            unmaskbtn ||
            recordCheckDataUnmask
          }
        >
          Unmask
        </RACButton>
      </div>

      <div className={cusClasses.px3}>
        <img
          className={`${cusClasses.accordionIconGrid} ${cusClasses.me2}`}
          src={openSection === 'phones' ? AccordionOpen : AccordionClose}
          alt="Accordion Icon"
          onClick={() => handleToggle('phones')}
        />
        <Typography display="inline" variant="body1" color="primary">
          Potential Phone Numbers
        </Typography>
      </div>
      {openSection === 'phones' && renderTable('phones')}

      <div className={cusClasses.px3}>
        <img
          className={`${cusClasses.accordionIconGrid} ${cusClasses.me2}`}
          src={openSection === 'emails' ? AccordionOpen : AccordionClose}
          alt="Accordion Icon"
          onClick={() => handleToggle('emails')}
        />
        <Typography display="inline" variant="body1" color="primary">
          Potential Emails
        </Typography>
      </div>
      {openSection === 'emails' && renderTable('emails')}

      <div className={cusClasses.px3}>
        <img
          className={`${cusClasses.accordionIconGrid} ${cusClasses.me2}`}
          src={openSection === 'addresses' ? AccordionOpen : AccordionClose}
          alt="Accordion Icon"
          onClick={() => handleToggle('addresses')}
        />
        <Typography display="inline" variant="body1" color="primary">
          Potential Addresses
        </Typography>
      </div>
      {openSection === 'addresses' && renderTable('addresses')}

      <div className={cusClasses.px3}>
        <img
          className={`${cusClasses.accordionIconGrid} ${cusClasses.me2}`}
          src={openSection === 'employers' ? AccordionOpen : AccordionClose}
          alt="Accordion Icon"
          onClick={() => handleToggle('employers')}
        />
        <Typography display="inline" variant="body1" color="primary">
          Potential Employers
        </Typography>
      </div>
      {openSection === 'employers' && renderTable('employers')}

      <div className={cusClasses.px3}>
        <img
          className={`${cusClasses.accordionIconGrid} ${cusClasses.me2}`}
          src={openSection === 'references' ? AccordionOpen : AccordionClose}
          alt="Accordion Icon"
          onClick={() => handleToggle('references')}
        />
        <Typography display="inline" variant="body1" color="primary">
          Potential References
        </Typography>
      </div>
      {openSection === 'references' && renderTable('references')}
    </div>
  ) : (
    <div className={cusClasses.noData}>
      <Typography variant="h6" color="textSecondary" align="center">
        {RECORD_CHECK_NO_DATA_1}
      </Typography>
      <Typography variant="h6" color="textSecondary" align="center">
        {RECORD_CHECK_NO_DATA_2}
      </Typography>
    </div>
  );
};

export const ContactInformationRecordCheckContent = (props: any) =>
  withContactStyles(props)(ContactInformationRecordCheckContent_);
